import React, { useEffect, useState } from "react";
import "./product.css";
import Footer from "../footer/footer";

const API = "https://lismount-api.onrender.com/api";

const ProductCertificate = () => {

  const [products, setProducts] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {

    const fetchProducts = async () => {

      const res = await fetch(`${API}/products`);
      const data = await res.json();

      setProducts(data);

    };

    fetchProducts();

  }, []);


  return (
    <>
      <div className="product-certificate-page">
        <div className="product-certificate-section">
          <h2 className="section-title underline-title">Our Products</h2>

          <div className="product-grid">

            {products.map((item) => (

              <div
                key={item.id}
                className={`product-card ${!item.inStock ? "disabled" : ""}`}
                onClick={() => {

                  if (!item.inStock) return;

                  setSelectedImage(item.image);
                  setSelectedProduct(item);

                }}
              >

                {!item.inStock && (
                  <span className="out-of-stock">Out of Stock</span>
                )}

                <img
                  src={item.image}
                  alt={item.name}
                  className="product-img"
                />

                <p className="product-name">{item.name}</p>

              </div>

            ))}

          </div>


          {selectedImage && selectedProduct && (

            <div
              className="custom-modal-overlay"
              onClick={() => {

                setSelectedImage(null);
                setSelectedProduct(null);

              }}
            >

              <div
                className="custom-modal image-modal-box"
                onClick={(e) => e.stopPropagation()}
              >

                <button
                  className="close-btn"
                  onClick={() => {

                    setSelectedImage(null);
                    setSelectedProduct(null);

                  }}
                >
                  ✕
                </button>

                <div className="modal-content-wrapper">

                  <img
                    src={selectedImage}
                    alt={selectedProduct.name}
                    className="modal-image"
                  />

                  <div className="modal-description">

                    <h3 className="modal-product-title">
                      {selectedProduct.name}
                    </h3>

                    <p className="modal-product-text">
                      {selectedProduct.description}
                    </p>

                  </div>

                </div>

              </div>

            </div>

          )}

        </div>

        <Footer />
      </div>
    </>
  );
};

export default ProductCertificate;